import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'

interface GetUserVenuesProps {
  cb?: (venues: any) => void
}


export const getUserVenues = createAsyncThunk('userInfo/getUserVenues',
  async ({ cb }: GetUserVenuesProps) => {
    const url = 'v1/user-info/venues'
    const response: AxiosResponse<Venue[]> = await instance.get(url)
    if (cb) {
      cb(response.data)
    }
    return response.data
  })